import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { createConnectQueryKey, useTransport } from '@connectrpc/connect-query'
import { supabase } from '@/lib/supabase'
import {
  listInAppNotifications,
  getUnreadNotificationCount,
} from '@/gen/cortado/v1/cortado-CortadoService_connectquery'

/**
 * Subscribes to Supabase Realtime for in-app notification updates.
 * Invalidates the notification list and unread count caches on changes.
 */
export function useNotificationRealtime(userId: string | undefined) {
  const queryClient = useQueryClient()
  const transport = useTransport()

  useEffect(() => {
    if (!userId) return

    const channel = supabase.channel(`notifications:user_${userId}`)

    const invalidateNotifications = () => {
      queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: listInAppNotifications,
          transport,
          cardinality: undefined,
        }),
      })
      queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: getUnreadNotificationCount,
          transport,
          cardinality: undefined,
        }),
      })
    }

    channel
      .on('broadcast', { event: 'new_notification' }, invalidateNotifications)
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [userId, queryClient, transport])
}
